export const environment = (window as any).__env__ as {
  // Define environment types here like
  production: boolean;
  gaTrackingId: string;
  baseUrl: string;
  env: string;
};
